import IComponent from "components/commons/IComponent";
import "./Show.scoped.css";
// import Button from "@material-ui/core/Button";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import "./PanelBase.scoped.css";
import * as geoprocessor from "@arcgis/core/rest/geoprocessor.js";
import DivTable from "components/commons/DivTable";
import Button from "@material-ui/core/Button";

let _ground_data = null;
class Show extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      features: undefined,
      isLoading: false,
      GrandTotal: undefined,
    };
  }
  componentDidMount() {
    this.callAsyncGpServiceExample();
    this.props.mapUICallback("DisaleAllWhenShowPanel");
  }
  componentWillUnmount() {}

  downloadcsv() {
    let sb = [];

    //download csv
    let header = "District,Cut,Fill,Wall,DT,ND,NS,\r\n";

    console.log(_ground_data);

    if (_ground_data != null) {
      sb = _ground_data.map((i, index) => {
        return index === _ground_data.length - 1
          ? i.district +
              "," +
              i.cut +
              "," +
              i.wall +
              "," +
              i.dt +
              "," +
              i.fill +
              "," +
              i.nd +
              "," +
              i.ns +
              "," +
              this.state.GrandTotal
          : i.district +
              "," +
              i.cut +
              "," +
              i.wall +
              "," +
              i.dt +
              "," +
              i.fill +
              "," +
              i.nd +
              "," +
              i.ns;
      });
    }

    let date = new Date();

    let currentDateTime =
      date.getFullYear() +
      (date.getMonth() + 1).toLocaleString("en-US", {
        minimumIntegerDigits: 2,
      }) +
      date.getDate().toLocaleString("en-US", { minimumIntegerDigits: 2 }) +
      date.getHours() +
      date.getMinutes();

    this.startDownload(
      header + sb.join("\r\n"),
      currentDateTime + ".csv",
      "data:text/csv;charset=utf-8",
      false
    );
  }

  startDownload(data, filename, type, isImage) {
    // http://stackoverflow.com/questions/13405129
    var a = document.createElement("a"),
      file = new Blob([data], { type: type });
    // https://msdn.microsoft.com/en-us/library/hh772332(v=vs.85).aspx
    if (window.navigator.msSaveOrOpenBlob)
      // IE10+
      window.navigator.msSaveOrOpenBlob(file, filename);
    else {
      // Others
      var url = isImage ? data : URL.createObjectURL(file);
      a.href = url;
      //"download" is a native HTML5 "A" attribute
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    }
  }

  async callAsyncGpServiceExample() {
    // try {
    this.setState({ isLoading: true });
    // this.props.showDialog({
    //   isOpen: true,
    //   title: "Loading",
    //   content: (
    //     <div>
    //       <span className="icn_loading" />
    //       Initializing GIS data, please wait...
    //     </div>
    //   ),
    // });
    let url = this.$config.gpToolUrls.countFeatureType;
    let params = {};
    let options = {
      userProxy: this.$config.useEsriProxy,
    };

    let result = await geoprocessor.submitJob(url, params, undefined, options);
    // Get the result with either fetchResultData(), fetchResultImage(), or fetchResultMapImageLayer();

    let R = await result.waitForJobCompletion();

    let finalR = await R.fetchResultData("output_Layer");
    let temp_array = [];
    console.log(finalR);

    finalR = await finalR.value.features.reduce((p, c, i) => {
      if (c.attributes.NAME.trim().length === 0) return;

      temp_array.push({
        district: c.attributes.NAME,
        cut: c.attributes.cut,
        wall: c.attributes.RWall,
        dt: c.attributes.DT,
        fill: c.attributes.fill,
        nd: c.attributes.ND,
        ns: c.attributes.NS,
      });
      return temp_array;
    }, []);
    console.log(finalR);

    let calculation = {
      district: "Total",
      cut: finalR.reduce((p, c, i) => {
        p += c.cut;
        return p;
      }, 0),
      wall: finalR.reduce((p, c, i) => {
        p += c.wall;
        return p;
      }, 0),
      dt: finalR.reduce((p, c, i) => {
        p += c.dt;
        return p;
      }, 0),
      fill: finalR.reduce((p, c, i) => {
        p += c.fill;
        return p;
      }, 0),
      nd: finalR.reduce((p, c, i) => {
        p += c.nd;
        return p;
      }, 0),
      ns: finalR.reduce((p, c, i) => {
        p += c.ns;
        return p;
      }, 0),
    };

    let G_taotal =
      calculation.cut +
      calculation.wall +
      calculation.dt +
      calculation.fill +
      calculation.nd +
      calculation.ns;

    finalR.push(calculation);

    _ground_data = finalR;
    console.log(_ground_data);
    this.setState({ features: finalR, isLoading: false, GrandTotal: G_taotal });
    // this.props.showDialog({
    //   isOpen: false,
    // });
  }
  render() {
    let { features, isLoading, GrandTotal } = this.state;
    return (
      <div>
        <div className="PanelBaseTitle EqualWidthChildren">
          <span>Feature Distribution Across District Councils</span>
          <div />
          <span
            className="icn_3d_Elevationprofile_close CloseButton"
            onClick={() => this.props.mapUICallback("hideAllPanel")}
          />
        </div>

        <div className="PanelContent">
          <div style={{ height: "500px" }}>
            <DivTable
              data={features}
              columnDef={[
                {
                  name: "District",
                  value: "district",
                  width: "230px",
                },
                {
                  name: "Cut",
                  value: "cut",
                },
                {
                  name: "Fill",
                  value: "fill",
                },
                {
                  name: "Wall",
                  value: "wall",
                },
                {
                  name: "DT",
                  value: "dt",
                },
                {
                  name: "ND",
                  value: "nd",
                },
                {
                  name: "NS",
                  value: "ns",
                },
              ]}
              noDataText={function() {
                if (isLoading)
                  return (
                    <div className="SubPanelContent">
                      <div>
                        <span className="icn_loading" /> Refreshing your feature
                        distribution..
                      </div>
                      <div
                        style={{
                          textAlign: "center",
                          padding: "10px",
                        }}
                      >
                        ***Close the window to cancel process***
                      </div>
                    </div>
                  );
              }.apply(this)}
            />
          </div>
        </div>
        {!isLoading && (
          <div className="bottomArea">
            <span>Grand Total = {" " + GrandTotal}</span>
            <Button
              style={{ float: "right" }}
              onClick={() => {
                this.downloadcsv();
              }}
            >
              <span className="icn_3d_Elevationprofile_export" />
            </Button>
          </div>
        )}
      </div>
    );
  }
}

export default Show;
